<div [formGroup]="dataForm" class="aside-content aside-width-3">
  <div class="aside-header fx-layout-row fx-layout-align-space-between-m fx-layout-align-center-x">
    <h3>{{ saveText }} Time Provider</h3>
    <div class="fx-layout-row fx-gap-10">
      <button mat-raised-button (click)="save()" color="primary">{{ saveText }}</button>
      <button mat-raised-button (click)="cancel()">Cancel</button>
    </div>
  </div>
  <div>
    <div>Current time is {{ currentDateTime() | date: 'dd-MMM-yyyy hh:mm' }}</div>
    <div>
      <mat-checkbox formControlName="realTime">Real Time</mat-checkbox>
    </div>
    @if (showIncremental()) {
      <div>
        <mat-checkbox formControlName="incrementTime">Incremental Time</mat-checkbox>
      </div>
    }

    @if (showIncremental() && incrementTime.value) {
      <div>
        <input matInput formControlName="incrementDays">
      </div>
    }
    @if (showFixed() && !incrementTime.value) {
      <div>
        <mat-checkbox formControlName="fixedTime">Fixed Time</mat-checkbox>
      </div>
    }
    @if (showFixed() && !incrementTime.value) {
      <div>
        <mat-form-field>
          <mat-label>Choose a Date</mat-label>
          <input formControlName="baseDate" matInput [matDatepicker]="dpBaseDate">
          <mat-datepicker-toggle matSuffix [for]="dpBaseDate"></mat-datepicker-toggle>
          <mat-datepicker #dpBaseDate></mat-datepicker>
        </mat-form-field>
      </div>
    }
  </div>
</div>
